import { BlogList } from '@/legacy/blocks/BlogList'
import { LATEST_ARTICLES_SORT } from '@/legacy/core/blog/constants'
import { ArticlesContextProvider } from '@/legacy/providers'

import type { BlogLayoutProps } from '../BlogLayout'

export function LatestArticlesSection({
  product,
  latestArticles,
}: { product?: BlogLayoutProps['product'] } & Pick<BlogLayoutProps, 'latestArticles'>) {
  return (
    <ArticlesContextProvider
      articles={latestArticles}
      sort={LATEST_ARTICLES_SORT}
      product={product || undefined}
    >
      <BlogList title={{ text: 'Mais recentes' }} showMore />
    </ArticlesContextProvider>
  )
}
